import * as actionType from "../../../context/actions";
import GetSaleReturnDataLocal from "./GetSaleReturnDataLocal";

const DeleteSaleReturnDataInLocal = async (state, dispatch, uniqueID) => {

    try {

        // Retrieve existing invoices from localStorage
        let existingData = JSON.parse(localStorage.getItem("LOCAL_SALE_RETURN")) || [];

        // Find the index of the invoice with the matching invoiceId
        const indexToDelete = existingData.findIndex((invoice, index) => invoice.uniqueID === uniqueID || index === uniqueID || invoice.id === uniqueID);

        // Validate if the invoice exists
        if (indexToDelete === -1) {
            return { success: true, message: "Sale Return deleted successfully!" };
        }

        // Remove the invoice at the found index
        existingData.splice(indexToDelete, 1);

        // Save updated data back to localStorage
        localStorage.setItem("LOCAL_SALE_RETURN", JSON.stringify(existingData));

        setTimeout(() => {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
        }, 5000);

        // Refresh invoice data
        await GetSaleReturnDataLocal(state, dispatch);

        return { success: true, message: "Sale Return deleted successfully!" };
    } catch (error) {
        return { success: false, message: error.message || error };
    }
};

export default DeleteSaleReturnDataInLocal;
